import {
  color,
  ExternalSvg,
  Flex,
  PrimaryText,
  spacing,
  useColorMode,
} from 'deepstash-ui';
import React from 'react';
import { SourceTitleByTypeSize } from './SourceTitleByType';

interface SourceDomainProps {
  domain: string;
  size?: SourceTitleByTypeSize;
  hasExternalSvg?: boolean;
  /**
   * Wether to have a static sourceDomain that is not interactable
   */
  isNotInteractable?: boolean;
}

const SourceDomain: React.FC<SourceDomainProps> = ({
  domain,
  size,
  hasExternalSvg = true,
  isNotInteractable,
}) => {
  const { colorMode } = useColorMode();

  return (
    <Flex alignItems="center">
      {domain && (
        <PrimaryText
          color={color[colorMode].textSecondary}
          size={size === 'sm' ? 'xs' : 's'}
          _hover={
            hasExternalSvg && !isNotInteractable
              ? { textDecoration: 'underline', cursor: 'pointer' }
              : undefined
          }
          noOfLines={1}
          overflowWrap="anywhere"
        >
          {domain}
        </PrimaryText>
      )}

      {hasExternalSvg && domain && !isNotInteractable && (
        <ExternalSvg
          color={color[colorMode].textSecondary}
          ml={spacing.XXS.rem}
          boxSize={size === 'sm' ? spacing.S.rem : spacing.M.rem}
          minWidth={size === 'sm' ? spacing.S.rem : spacing.M.rem}
        />
      )}
    </Flex>
  );
};

export default SourceDomain;
